class Element {
    load() {
        throw new Error("Method .load() is not implemented");
    }

    unload() {
        throw new Error("Method .unload() is not implemented");
    }
}

class AsyncLoader {
    constructor(makeElement) {
        this._makeElement = makeElement;
        this._elements = new Map();
    }

    load(key) {
        let elementEntry = this._elements.get(key);

        if (!elementEntry) {
            elementEntry = {
                loadCount: 0,
                promise: null,
                element: this._makeElement(key),
            };

            this._elements.set(key, elementEntry);

            elementEntry.promise = elementEntry.element.load();
        }

        elementEntry.loadCount++;
        return elementEntry.promise;
    }

    unload(key) {
        const elementEntry = this._elements.get(key);
        elementEntry.loadCount--;

        if (elementEntry.loadCount === 0) {
            elementEntry.element.unload();
            this._elements.delete(key);
        }
    }
}

AsyncLoader.Element = Element;

export default AsyncLoader;
export { AsyncLoader, Element };
